import * as React from 'react';

import { getDeltaModifier, toDeltaFormat } from './Dashboard.formatters';

interface StatCardProps {
  accent: string;
  children?: React.ReactNode;
  comparisonLabel?: string;
  deltaPercentage?: number | null;
  /** Unrounded figure shown under an abbreviated value, so the headline stays auditable. */
  exactValue?: string;
  icon: string;
  label: string;
  unit?: string;
  value: string;
}

export const StatCard = (props: StatCardProps) => {
  const { accent, children, comparisonLabel, deltaPercentage, exactValue, icon, label, unit, value } = props;
  const hasDelta = deltaPercentage !== undefined;

  return (
    <div className="Dashboard__card Dashboard__stat-card">
      <div className="Dashboard__stat-card-header">
        <span className={`Dashboard__stat-icon Dashboard__stat-icon--${accent}`}>{icon}</span>
        <span className="Dashboard__stat-label">{label}</span>
      </div>

      <div className="Dashboard__stat-value" title={exactValue || undefined}>
        {value}
      </div>
      {exactValue && <div className="Dashboard__stat-exact">{exactValue}</div>}
      {unit && <div className="Dashboard__stat-unit">{unit}</div>}

      {children}

      {hasDelta && (
        <div className="Dashboard__stat-footer">
          <span className={`Dashboard__delta Dashboard__delta--${getDeltaModifier(deltaPercentage!)}`}>
            {toDeltaFormat(deltaPercentage!)}
          </span>
          {comparisonLabel && <span className="Dashboard__stat-comparison">{comparisonLabel}</span>}
        </div>
      )}
    </div>
  );
};
